import React from 'react';
import { translate } from '@utils/i18n';
import { GenericEventType } from '@features/Calendar/constants';
import { Controller, useFormContext } from 'react-hook-form';
function EventTypeSelector() {
    const namespace = 'features.modals.new_generic_event_modal.basic_information_section.event_type_selector';
    const { control } = useFormContext();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'eventTypeTitle' }, translate('what_type', { namespace })),
        React.createElement("div", { className: 'eventTypeRadioGroup' }, Object.values(GenericEventType).map((type) => (React.createElement(Controller, { key: type, name: "eventType", control: control, rules: { required: true }, render: ({ field }) => (React.createElement("label", { className: "qmb-radio eventTypeRadio" },
                React.createElement("input", { type: "radio", name: field.name, value: type, checked: field.value === type, onChange: field.onChange }),
                translate(type, { namespace }))) }))))));
}
export default EventTypeSelector;
